/**
 * Extended functionality for the input-select control to handle
 * non standard url navigation on select change
 */
 function updateBindings () {
  document.querySelectorAll('input-select').forEach(function (el) {
    el.addEventListener('change', function (event) {
      const option = event.target.selectedOption
      if (option && option.dataset.url) {
        global.location.href = option.dataset.url
      }
    })
  })
}

updateBindings();